import { GridColDef, GridValueFormatterParams, GridValueGetterParams } from '@mui/x-data-grid-pro'

import { FieldModel } from '@cibo/core'
import { intuitiveFromNow } from '@cibo/ui'
import { FieldColumnProps } from './types'

export interface FieldEnrollmentColumnProps extends FieldColumnProps {
  programId: string
}

export const fieldEnrollmentColumn = ({
  t,
  programId,
  ...columnProps
}: FieldEnrollmentColumnProps) =>
  ({
    field: 'commit',
    headerName: t('enrolledOn', { ns: '@cibo/landmanager/FieldColumns' }),
    sortable: false,
    filterable: false,
    valueGetter: (params: GridValueGetterParams<any, FieldModel>) =>
      params.row.enrolledAt(programId),
    valueFormatter: (params: GridValueFormatterParams<string>) =>
      params.value ? intuitiveFromNow(params.value) : '--',
    ...columnProps,
  } as GridColDef<FieldModel>)
